module.exports = __webpack_public_path__ + "static/media/gray_scale.b3dc56c4.jpg";